import { Box, styled } from "@mui/material";

export const AddBlockOffModalStyled = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  min-height: 250px;
  justify-content: center;
  .fields-wrapper {
    display: grid;
    grid-template-columns: 187px 1fr;
    column-gap: 16px;
  }
`;
